import { useState } from "react";
import { getSeq } from "../../../../../helpers/get-seq";
import { Button } from "../../../utils/landing-page/button";
import {
  HamburgerMenu,
  MobileMenu,
} from "../../../utils/landing-page/hamburger-menu";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "../../../utils/landing-page/navigation-menu";
import "./index.scss";
import { useNavigate } from "react-router-dom";

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  
  const handlePlatformAccess = () => {
    navigate("/app")
  };

  const navItems = [
    { label: "A propos", href: "#apropos" },
    { label: "Statistiques", href: "#solution" },
    { label: "Fonctionnalités", href: "#fonctionalite" },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="HeaderSection">
      <div className="HeaderSection-backgroundDecoration" />

      <div className="HeaderSection-mainContainer">
        <img src="/benin.png" alt="Logo" className="HeaderSection-logo" />

        <div className="HeaderSection-navigationWrapper">
          <div className="HeaderSection-navigationContainer">
            <div className="HeaderSection-navigationInner">
              <NavigationMenu className="HeaderSection-navigationMenu">
                <NavigationMenuList className="HeaderSection-navigationList">
                  {navItems.map((item, index) => (
                    <NavigationMenuItem key={`landing-page-navitem-${getSeq()}-${index}`}>
                      <NavigationMenuLink
                        className="HeaderSection-navigationLink"
                        href={item.href}
                      >
                        {item.label}
                      </NavigationMenuLink>
                    </NavigationMenuItem>
                  ))}
                  <NavigationMenuItem>
                    <Button className="HeaderSection-platformButton" onClick={handlePlatformAccess}>
                      Accès plateforme
                    </Button>
                  </NavigationMenuItem>
                </NavigationMenuList>
              </NavigationMenu>

              <HamburgerMenu isOpen={isMobileMenuOpen} onToggle={toggleMobileMenu} />
            </div>
          </div>
        </div>
      </div>

      <MobileMenu isOpen={isMobileMenuOpen} onClose={closeMobileMenu} navItems={navItems} onPlatformAccess={handlePlatformAccess} />
    </header>
  );
}
